import { authenticatedFetch } from 'api/fetch';
import { DiscoveryShareDateResponse } from './discoveryShareDateApiTypes';

export const getDiscoveryShareDate = async (
  profileId: string,
): Promise<string | null> => {
  const { json } = await authenticatedFetch<DiscoveryShareDateResponse>(
    `/api/v1/profiles/shared-date`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ profileIds: [profileId] }),
    },
  );

  const { profiles } = await json();

  return (
    profiles.find((profile) => profile.profileId === profileId)?.details
      .lastSharedAt ?? null
  );
};
